<template>
  <div class="profile-panel-body-wrapper">
    <div class="profile-panel-filter-search">
      <!-- <div class="nft-panel-minted">
        <div class="nft-panel-theos" @click="setTheosMinted(true)">
          <img :src="theosMintedCheckboxIcon()" alt="checkbox" />
          <p>Theos-minted</p>
        </div>
        <div class="nft-panel-theos" @click="setTheosMinted(false)">
          <img :src="otherPlatformsMintedCheckboxIcon()" alt="checkbox" />
          <p>Minted on other platforms</p>
        </div>
      </div> -->
      <div class="profile-panel-search">
        <app-input
          v-model="searchString"
          :value="searchString"
          placeholder="Search by name, pool, tag or cause"
          inputClass="app-modal-input"
          @keyup.enter="search()"
          class="search-input"
          :disabled="!theosMinted"
        />
        <img
          src="@/Common/Icons/search-icon.png"
          alt="search"
          class="profile-panel-search-icon"
        />
      </div>
    </div>
    <theos-minted-nfts v-if="theosMinted"></theos-minted-nfts>
    <non-theos-minted-nfts v-else></non-theos-minted-nfts>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import AppInput from "@/elements/AppInput";
import useProfilePanels from "@/composables/useProfilePanels";
import TheosMintedNfts from "@/components/Profile/TheosMintedNfts";
import NonTheosMintedNfts from "@/components/Profile/NonTheosMintedNfts";

export default {
  components: {
    AppInput,
    TheosMintedNfts,
    NonTheosMintedNfts,
  },
  setup() {
    const store = useStore();

    const {
      nftsList,
      searchString,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      search,
      loadMore,
      params,
      nftDataList,
      toggleFilter,
      loadingNfts,
      theosMinted,
      theosMintedCheckboxIcon,
      otherPlatformsMintedCheckboxIcon,
      setTheosMinted,
    } = useProfilePanels(store);

    const router = useRouter();
    const openMintingForm = () => router.push("/");

    const goToNftDetails = (nftId) => {
      router.push({ name: "NftDetails", params: { id: nftId } });
      store.dispatch("nftDetails/resetState");
    };

    onMounted(() => {
      setTheosMinted();
    });

    return {
      nftsList,
      searchString,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      search,
      openMintingForm,
      loadMore,
      params,
      nftDataList,
      toggleFilter,
      loadingNfts,
      theosMinted,
      theosMintedCheckboxIcon,
      otherPlatformsMintedCheckboxIcon,
      setTheosMinted,
      goToNftDetails,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profilePanels.scss"></style>
